
/** Nutzung:
 * Mit URL Link
 * <html-brand-button :link="{ Linkziel }">{ Text }</html-brand-button>
 *
 * <html-brand-button :link="localePath('shops')">Standorte</html-brand-button>
 * <html-brand-button :link="https://www.acredo-trauringe.de">Acredo Website</html-brand-button>
 *
 * Mit Klick-Event
 * <html-brand-button @click.native="{ Funktion }">{ Text }</html-brand-button>
 */

import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['link', 'textColor', 'target'],
  setup() {},
})
